import React, { useState } from 'react'

import { Helmet } from 'react-helmet-async';
import { useAuth0 } from '@auth0/auth0-react';
import styles from './UnauthorizedPage.module.sass';
import Button from 'Components/Atoms/ButtonDeprecated/Button';
import logoAnimated from 'Assets/Icons/logo-animated.svg';

export const UnauthorizedPage = () => {
    const { logout } = useAuth0();
    
    return <>
        <Helmet>
            <title>Geen toegang - Growing People</title>
        </Helmet>

        <div className={styles.container}>
            <img src={logoAnimated} width="300px" />

            <div className={styles.message_container}>
                <div className={styles.message}>Je hebt geen toegang tot Growing People.</div>
                <div className={styles.submessage}>Vraag aan de Systeem Beheerder om toegang en probeer later nog een keer. CODE: APP</div>
            </div>

            <Button
                variant='transparent'
                color='primary'
                onClick={() => logout({
                    returnTo: window.location.origin
                })}
            >
                Probeer een ander mailadres
            </Button>
        </div>
    </>;
}